import { Component, Input } from '@angular/core';
import { ContactModel } from 'models/generated/Entities.GormCrm.Contact';
import { Layout } from 'modules/layout';
import { PhoneNumberPipe } from 'pipes/phone-number.pipe';
import { ComponentUrl } from 'services/navigation.service';


@Component({
	selector: 'contact-card',
	templateUrl: './contact-card.component.html',
	styleUrls: ['./contact-card.component.scss'],
	imports: [Layout, PhoneNumberPipe]
})
@ComponentUrl('contact-card.component')
export class ContactCardComponent {

	@Input() showEmail = false;
	@Input() showPhone = false;

	private _contact: ContactModel = new ContactModel;
	@Input()
	set contact(contact: ContactModel) {
		this._contact = contact;
	}
	get contact() {
		return this._contact;
	}
}
